export default __webpack_public_path__ + "static/media/warning--double-curve-first-right--g1.a3423d11.png";